import React, { useMemo, useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { setShowHelpSection } from "../../slices/helpContentSlice";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";

function UserGuide(props) {
    const {
        showUserGuide,
        handleBack,
        userGuideVideo = {},
        setShowUserGuide,
        handleHelpClose,
    } = props?.helpSectionProps || {};
    const dispatch = useDispatch();
    const [animationClass, setAnimationClass] = useState("slide-in");
    const { Content = [] } = userGuideVideo;

    const initialVideos = useMemo(
        () =>
            Content?.map((video, index) => ({
                ...video,
                order: index + 1,
            })) || [],
        [Content]
    );

    const [videos, setVideos] = useState(() => initialVideos.slice(1));
    const [mainVideo, setMainVideo] = useState(() => initialVideos[0] || null);
    const [isAutoPlay, setAutoPlay] = useState(false);

    useEffect(() => {
        const sortedVideos = [...initialVideos].sort(
            (a, b) => a.order - b.order
        );
        setMainVideo(sortedVideos[0] || null);
        setVideos(sortedVideos.slice(1));
        setAutoPlay(false);
    }, [initialVideos]);

    const handleVideoClick = (clickedVideo) => {
        setMainVideo(clickedVideo);
        setVideos([
            mainVideo,
            ...videos.filter((video) => video.order !== clickedVideo.order),
        ]);
    };

    // Handle modal close
    const handleClose = () => {
        setAnimationClass("slide-out");
        handleHelpClose();
        dispatch(setShowHelpSection(false));
    };

    const handleBackHelp = () => {
        setAnimationClass("slide-out");
        setTimeout(() => {
            setShowUserGuide(false);
            handleBack();
        }, 1100);
    };

    return (
        <Modal
            show={showUserGuide}
            dialogClassName="help-section overflow-hidden"
            size="xl"
            backdrop="true"
            onHide={handleClose}
            backdropClassName="helpContent-backdrop"
            className={animationClass}
        >
            <div
                className="training-videos-container"
                style={{
                    padding:
                        Content?.length > 1
                            ? "32px 0px 64px 12px"
                            : "32px 32px 64px",
                }}
            >
                <Modal.Header
                    style={{
                        justifyContent: "space-between",
                        padding:
                            Content?.length > 1 ? "0px 32px 0px 20px" : "0px",
                    }}
                >
                    <button
                        className="help-buttons align-items-center border-0 bg-transparent"
                        style={{ fontWeight: 700 }}
                        onClick={handleBackHelp}
                    >
                        <i className="fa-solid fa-angle-left"></i> Back
                    </button>
                    <button
                        className="help-buttons align-items-center border-0 bg-transparent"
                        onClick={handleClose}
                    >
                        <i className="fa-solid fa-xmark"></i> Close
                    </button>
                </Modal.Header>
                <Modal.Body
                    className="videoBody"
                    style={{
                        maxHeight: "calc(100vh - 100px)",
                        overflowY: "auto",
                    }}
                >
                    <div>
                        <div className="user-guide-container">
                            <div
                                style={{
                                    padding:
                                        Content?.length > 1
                                            ? "0px 32px 0px 20px"
                                            : "0px",
                                }}
                            >
                                <div className="header pb-3 pt-20p">
                                    User Guides and Videos
                                </div>
                                <div className="d-flex justify-content-start pb-20p">
                                    {mainVideo?.Description ? (
                                        <iframe
                                            className="user-guide"
                                            src={`${mainVideo?.Description}${isAutoPlay ? "&autoplay=1" : ""}`}
                                            width="140"
                                            height="160"
                                            frameBorder="0"
                                            allow="autoplay; fullscreen; picture-in-picture"
                                            allowFullScreen
                                            title="User Guide Video"
                                        ></iframe>
                                    ) : (
                                        <p>Video content not available.</p>
                                    )}
                                </div>
                                <div className="diagnostic-paragraph">
                                    {mainVideo?.Header ||
                                        "Description not available."}
                                </div>
                            </div>
                            {Content?.length > 1 && (
                                <div
                                    className="header"
                                    style={{ padding: "10px 32px 6px 20px" }}
                                >
                                    More Videos
                                </div>
                            )}
                            <div className="d-flex pb-20p moreVideosContainer">
                                {videos?.map((video) => (
                                    <li className="videoList" key={video.order}>
                                        <iframe
                                            className="userGuideVideos"
                                            src={`${video?.Description}&controls=0`}
                                            allow="fullscreen; picture-in-picture"
                                            title="User Guide Video"
                                        ></iframe>
                                        <div style={{}}>
                                            {video?.Header ||
                                                "Description not available."}
                                        </div>
                                        <button
                                            type="button"
                                            className="videoSelectButton"
                                            aria-label={`Play ${video?.Header || "user guide video"}`}
                                            onClick={() => {
                                                setAutoPlay(true);
                                                handleVideoClick(video);
                                            }}
                                        ></button>
                                    </li>
                                ))}
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </div>
        </Modal>
    );
}

UserGuide.propTypes = {
    helpSectionProps: PropTypes.shape({
        showUserGuide: PropTypes.bool,
        handleBack: PropTypes.func,
        handleHelpClose: PropTypes.func,
    }),
};

export default UserGuide;
